import type { Prop } from '../../defs.ts'
import type { District } from '../plot.ts'
import { decals, look, row, woodsy } from '../kit.ts'

const CROPS = ['wheat', 'cabbage', 'pumpkin', 'sunflower', 'wheat']

/** Windmill Farm: crop rows, a barn, hay bales and a windmill you can see from anywhere. */
export const farm: District = {
  id: 'farm',
  name: 'Windmill Farm',
  ground: 'grass',
  ambience: ['fireflies'],
  build(p) {
    p.zone(0, 15, 36, 2, 'dirt'); p.zone(17, 0, 2, 32, 'dirt')
    p.zone(20, 2, 15, 11, 'dirt'); p.zone(20, 19, 15, 11, 'dirt')
    const rows: Prop[] = []
    ;[3, 5, 7, 9, 11].forEach((y, i) => { for (let x = 21; x < 34; x++) rows.push({ kind: 'crop', x, y, variant: CROPS[i] }) })
    ;[20, 22, 24, 26, 28].forEach((y, i) => { for (let x = 21; x < 34; x++) rows.push({ kind: 'crop', x, y, variant: CROPS[(i + 2) % CROPS.length] }) })
    p.prop(...rows)
    p.prop(
      { kind: 'windmill', x: 5, y: 4 },
      { kind: 'building', x: 2, y: 20, w: 5, d: 4, door: 2, color: '#fff6e0', roof: '#e07a5f' },
      { kind: 'building', x: 9, y: 20, w: 6, d: 5, door: 3, style: 'shack', color: '#c0504d', roof: '#7a3b2e', text: 'Barn' },
      { kind: 'hay', x: 10, y: 27 }, { kind: 'hay', x: 12, y: 27 }, { kind: 'hay', x: 13, y: 28 }, { kind: 'hay', x: 3, y: 10 }, { kind: 'hay', x: 4, y: 11 },
      { kind: 'signpost', x: 16, y: 14, text: 'Windmill Farm' },
    )
    p.tram(12, 12)
    p.place({ id: 'farm', name: 'Windmill Farm', blurb: 'Pumpkins, sunflowers and a windmill that never stops.', x: 18, y: 14, accent: '#e0b84a', r: 10 })
    p.scatter({ density: 0.04, pick: woodsy([['tree', 4], ['bush', 2]]) })
    p.critter({ kind: 'butterfly', loop: [[22, 4], [33, 6], [30, 12], [21, 10]], speed: 0.5 })
    p.critter({ kind: 'pigeon', loop: [[8.5, 26.5], [12.5, 26], [14.4, 29]], speed: 0.35 })
    p.npc({
      id: 'npc-farmer', name: 'Farmer Hay', role: 'Farmer', look: look('farmerhay', 1, 3, 3, 'cowboy'), speed: 1.1,
      stops: [
        { x: 25, y: 4, wait: 12, say: -1 },
        { x: 30, y: 8, wait: 12, emote: 'happy' },
        { x: 26, y: 23, wait: 12, say: -1 },
        { x: 11, y: 26, wait: 10, emote: 'thinking' },
      ],
      lines: ['Pumpkins are coming along nicely.', 'That windmill grinds the flour for the café.', 'Mind the cabbages, they bruise.', 'Hay there!'],
    })

    // ─── Detail ───
    p.prop(
      ...row('fence', 20, 26, 1), ...row('fence', 28, 34, 1), ...row('fence', 20, 26, 13), ...row('fence', 28, 34, 13),
      ...row('fence', 20, 26, 18), ...row('fence', 28, 34, 18), ...row('fence', 20, 26, 30), ...row('fence', 28, 34, 30),
      { kind: 'well', x: 5, y: 27 }, { kind: 'cart', x: 2, y: 13, color: '#c98d52' }, { kind: 'crate', x: 15, y: 21 }, { kind: 'barrel', x: 15, y: 22 },
      { kind: 'mailbox', x: 7, y: 25 }, { kind: 'aboard', x: 16, y: 17, text: 'Eggs' },
    )
    p.scatter(decals(['clover'], 0.06, ['grass']))
    for (const loop of [[[9.5, 26.5], [12.6, 29.2], [8.2, 29.6]], [[4.5, 18.5], [7.5, 17.6], [6.6, 19.6]], [[14.2, 28.5], [16.4, 27.2], [15.6, 29.6]]] as Array<Array<[number, number]>>) {
      p.critter({ kind: 'pigeon', color: '#fff8ee', loop, speed: 0.35 })
    }
    p.npc({
      id: 'npc-clover', name: 'Clover', role: 'Farm kid', look: look('kidclover', 6, 5, 4, 'sprout'), speed: 2.4,
      stops: [{ x: 11, y: 29, wait: 3, emote: 'happy', say: -1 }, { x: 6, y: 17, wait: 3 }, { x: 16, y: 27, wait: 4, say: -1 }],
      lines: ['The chickens are faster than they look!', 'Want an egg? They’re still warm.', 'I named that one Nugget. Don’t tell Dad.'],
    })
  },
}
